import { render, staticRenderFns } from "./ExaminePaper.vue?vue&type=template&id=a909015e&scoped=true"
import script from "./ExaminePaper.vue?vue&type=script&lang=js"
export * from "./ExaminePaper.vue?vue&type=script&lang=js"
import style0 from "./ExaminePaper.vue?vue&type=style&index=0&id=a909015e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a909015e",
  null
  
)

export default component.exports